export default __webpack_public_path__ + "d60121cf921e6ad10aa5b97a0d9b4603.woff";